__turbopack_context__.v({
  "addButton": "CandidateSelectList-module__gsjXVW__addButton",
  "avatarCell": "CandidateSelectList-module__gsjXVW__avatarCell",
  "divider": "CandidateSelectList-module__gsjXVW__divider",
  "group": "CandidateSelectList-module__gsjXVW__group",
  "item": "CandidateSelectList-module__gsjXVW__item",
  "itemBody": "CandidateSelectList-module__gsjXVW__itemBody",
  "itemName": "CandidateSelectList-module__gsjXVW__itemName",
  "itemRow": "CandidateSelectList-module__gsjXVW__itemRow",
  "itemSubtitle": "CandidateSelectList-module__gsjXVW__itemSubtitle",
  "itemWrapper": "CandidateSelectList-module__gsjXVW__itemWrapper",
  "pendingAvatar": "CandidateSelectList-module__gsjXVW__pendingAvatar",
  "removeButton": "CandidateSelectList-module__gsjXVW__removeButton",
  "root": "CandidateSelectList-module__gsjXVW__root",
  "warning": "CandidateSelectList-module__gsjXVW__warning",
});
